export default "__VITE_ASSET__fb62b36d__$_?component__"